module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Edit-2791bd191841e7067914c5856e58c308.svg";